import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { MainBar, MainBarMobile } from 'components/@kiniseko/Header';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const tenant = useSelector(state => state.tenant);

  return (
    <>
      { !isMobile && <MainBar email={tenant.email} location={location} /> }
      { isMobile && <MainBarMobile email={tenant.email} location={location} /> }
    </>
  );
};

export default Header;
